let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  // V_NUF_LP_01 | Add Light Labs Testing Badge to Main Landing Page
  // Intelligems names: "Control", "Var A - Below Gallery", "Var B - Below Purchase Area"
  const lightLabsTest = window.igData?.user.getTestGroup("03c323a0-a468-48a4-a342-ab285774110b");
  if (lightLabsTest?.name?.startsWith("Var A")) {
    document.body.classList.add('c-lightLabsVarA');
  } else if (lightLabsTest?.name?.startsWith("Var B")) {
    document.body.classList.add('c-lightLabsVarB');
  }

  // V_NUF_LP_06 | Reorder the Main Lander Image Gallery Around Proof (Lymphaire Inspo)
  // Intelligems names: "Control", "Var A - Proof-First Gallery"
  const proofGalleryTest = window.igData?.user.getTestGroup("5ecb8f76-c913-4732-9540-370a4aa36257");
  if (proofGalleryTest?.name?.startsWith("Var A")) {
    document.body.classList.add('c-nufLp06VarA');
  }

  // V_NUF_LP_02 | Email Signup Popup on Main Landing Page (Email Team Test)
  // Intelligems names: "Control", "Var A"
  const emailPopupTest = window.igData?.user.getTestGroup("5a96d76d-ea89-436a-bc57-117df18d7a37");
  if (emailPopupTest?.name?.startsWith("Var A")) {
    document.body.classList.add('c-nufLp02VarA');
  }

  document.body.classList.add('c-igReady');
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
